import { Outlet } from 'react-router';

import { MAIN_CONTENT_ID, useRouteChange } from '@hooks/useRouteChange';
import { useSystems } from '@hooks/useSystems';

import { AmbientBackground } from './AmbientBackground';
import { SiteHeader } from './header/SiteHeader';
import { SiteFooter } from './SiteFooter';
import styles from './AppLayout.module.scss';

/** Resets scroll and focus on navigation. A component so it can sit before the Outlet. */
const RouteChangeHandler = () => {
  useRouteChange();
  return null;
};

/**
 * The application shell, shared by every route: background, header,
 * footer. Only the Outlet changes between pages.
 *
 * RouteChangeHandler must precede the Outlet; see useRouteChange.
 */
export const AppLayout = () => {
  useSystems();

  return (
    <div className={styles.app}>
      <a href={`#${MAIN_CONTENT_ID}`} className={styles.skipLink}>
        Skip to content
      </a>

      <AmbientBackground />
      <SiteHeader />
      <RouteChangeHandler />
      <Outlet />
      <SiteFooter />
    </div>
  );
};
